import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import { Container, Row, Col } from 'reactstrap';
import TextInput from '../TextInput/TextInput';
import { getRecaptchaToken } from '../../../utilities/recaptcha/recaptcha';
import { showAppLoader, hideAppLoader } from '../Loader/LoaderSlice';
import BtnSubmit from '../Buttons/BtnSubmit';
import { validateFields, validateField } from '../../../utilities/validation/validator';
import { regexPatterns } from '../../../utilities/validation/validationVariables';
import { connect } from 'react-redux';
import ProviderManager from './../../../provider/providerManager';
import Config from '../../../Config';
import OtpInput from 'react-otp-input';

const OtpCode = (props) => {

    const [wrongOtpMessage, setWrongOtpMessage] = useState('');
    const [form, setForm] = useState({

        verifyCode: '',
        numOfAttempts: 0,
        valid: '',
        errors: {},
        rules: {
            verifyCode: {
                required: { value: true, error: 'לא הוזן קוד' },
                minLength: {
                    value: 6,
                    error: 'יש להזין 6 תווים',
                },
                pattern: {
                    value: regexPatterns.numbersRegex,
                    error: 'ערך לא תקין',
                }
            }
        }
    });


    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {

            clearCode();
        }
    });

    useEffect(() => {
        if ('OTPCredential' in window) {
            async function fetchOtp() {
                try {
                    const otp = await navigator.credentials.get({
                        otp: { transport: ['sms'] },
                    });
                    if (otp?.code) {
                        handleChange(otp.code);
                    }
                } catch (err) {
                    console.error('Error fetching OTP:', err);
                }
            }
            fetchOtp();
        }
    }, []);

    const clearIsValid = () => {
        form.valid = false;
        setForm(form);
    }

    const clearCode = () => {
        form.verifyCode = '';
        setForm(form);
    }

    const addAttempt = () => {


        const tempForm = Object.assign({}, validateFields(form));
        tempForm.numOfAttempts = form.numOfAttempts + 1;
        setForm(tempForm)

    }


    const readyToCreateOtp = () => {

        if (form.numOfAttempts >= Config.verifyCodeAttemptsLimit) return;

        if (props.phone != null && props.phone != undefined) {

            if (validateForm(form)) {
                props.showAppLoader();
                createOtp(false);
            }

        }
    };

    const readyToCreateVoiceOtp = () => {
        if (form.numOfAttempts >= Config.verifyCodeAttemptsLimit) return;

        if (props.phone != null && props.phone != undefined) {
            props.showAppLoader();
            createOtp(true);
        }
    };

    const createOtp = async (isVoice) => {
        const captchaToken = await getRecaptchaToken('OtpVerifyPhonePage');

        if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
            return;
        }

        try {
            const result = await ProviderManager.getProviderData('createOtp', [props.phone, isVoice, captchaToken]);
            if (result.Body && result.Body.step1Ticket) {

                props.onTicket({ otpCodeticketId: result.Body.step1Ticket });
                handleChange('clear');
                clearCode();
            }
        } catch (error) {
            console.info('createOtp', error);
            return null;
        } finally {
            props.hideAppLoader();
            addAttempt();
        }
    };

    const validateForm = (e) => {

        const form = Object.assign({}, validateFields(e));
        setForm(form);
        if (form.errors.verifyCode == '') {
            return true;
        }

        return false;
    }

    const handleChange = (otp) => {
        const tempForm = Object.assign({}, form);
        tempForm.verifyCode = otp;
        setForm(tempForm);
    };



    async function checkOtp() {
        const isValidOtp = await validateOtp();

        if (!isValidOtp) {
            addAttempt();
            setWrongOtpMessage("הקוד שהוזן אינו תקין, נסה שנית");
            return;
        }
        else {
            props.onSuccess({ isSuccess: true });
        }
    }

    async function validateOtp() {
        props.showAppLoader();
        try {
            const result = await ProviderManager.getProviderData('validateOtp', [props.phone, props.otpTicketId, form.verifyCode]);

            return result.Header.ReturnCode == 0;
        } catch (error) {
            console.info('validateOtp', error);
            return false;
        } finally {
            props.hideAppLoader();
        }
    }


    return (

        <div className='container-fluid main'>
            <div className='shared-otp-code'>
                <Row>
                    <Col ms={12}>
                        <h1 className='main-title'>{props.title}</h1>
                    </Col>
                </Row>
                <Row>
                    <Col ms={12}>
                        <h1 className='top-title'>{props.subTitle}</h1>
                    </Col>
                </Row>
                <Row>
                    <Col ms={12}>
                        <div className='component-container' style={{ backgroundColor: 'transparent' }}>
                            <div className='mainDiv'>
                                <OtpInput
                                    shouldAutoFocus={true}
                                    value={form.verifyCode}
                                    onChange={handleChange}
                                    numInputs={6}
                                    isInputNum={true}
                                    separator={<span className='inputSeparator'></span>}
                                    inputStyle='input-design'
                                    containerStyle='mainDivInside'
                                    renderInput={(inputProps, index) => (
                                      <input {...inputProps} key={index} autoComplete="one-time-code" />
                                    )}
                                />
                            </div>

                            {wrongOtpMessage != ''}
                            <br />
                            <div className='error-container'>
                                <div className='error'>{wrongOtpMessage}</div>
                            </div>

                            {form.numOfAttempts >= Config.verifyCodeAttemptsLimit ? <div className='error'>לא ניתן לבצע ניסיונות נוספים</div> : ''}

                            <section className='otp-btn-container'>
                                <div role='button' tabIndex='0' onClick={readyToCreateOtp}>
                                    <section className='otp-btn-container'>
                                        <div>
                                            <Image src={require('./images/sms.svg')} alt='לא קיבלתי קוד, שילחו לי שוב' />
                                        </div>
                                        <div>
                                            <span>
                                                הקוד לא הגיע, <br />
                          שלחו לי שוב
                        </span>
                                        </div>
                                    </section>
                                </div>
                                <div className='spacer'></div>
                                <div role='button' tabIndex='1' onClick={readyToCreateVoiceOtp}>
                                    <section className='otp-btn-container'>
                                        <div>
                                            <Image src={require('./images/voice.svg')} alt='שילחו לי קוד בהודעה קולית' />
                                        </div>
                                        <div>
                                            <span>
                                                שילחו לי קוד
                          <br />
                          בהודעה קולית
                        </span>
                                        </div>
                                    </section>
                                </div>
                            </section>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div style={{ textAlign: 'center' }}><BtnSubmit onclick={checkOtp} text={props.buttonText} /></div>
                    </Col>
                </Row>
            </div>
        </div>

    );
};

const mapStateToProps = (state) => {
    return {
        form: state.otpVerifyCode.form,
    };
};

const mapDispatchToProps = {
    showAppLoader,
    hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpCode);

